import React from 'react'
import "./AppDownload.css"
import {assets} from "../../assets/assets"
const AppDownload = () => {
  return (
    <div className='app-download' id='app-download'>
<p>For Enhanced Experience Download  <br /> OfficeBites App </p>

<div className="app-download-platforms">

 <img src={assets.play_store} alt="Corporate snack delivery Meru CBD OfficeBites,OfficeBites snack delivery service in Meru,Affordable office snacks delivery Meru with OfficeBites,Meru CBD snack delivery OfficeBites" />
 <img src={assets.app_store} alt="OfficeBites Morale-boosting snacks Meru, Office snack solutions in Meru by OfficeBites,Affordable office snacks delivery Meru,Meru CBD snack delivery OfficeBites " />

</div>





    </div>
  )
}

export default AppDownload